import React, { useState, useEffect, Fragment } from 'react'
import { useNavigate } from 'react-router-dom';
import CategoriesServices from '../../../Api/AdBazar/Categories/CategoriesServices';
import { Box, CardMedia, Chip, Grid, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Tooltip, Typography } from '@mui/material';
import BreadCrumbs from '../../../Components/BreadCrumbs/BreadCrumbs';
import Colors from '../../../Assets/Styles/Colors';
import { DeleteForever, Edit, KeyboardArrowLeft, KeyboardArrowRight } from '@mui/icons-material';
import { SecondaryButton } from '../../../Components/Buttons/index';
import FormDialog from '../../../Components/Dialogs/FormDialog';
import UFormDialog from '../../../Components/Dialogs/UFormDialog';
import ConfirmationDialog from '../../../Components/Dialogs/ConfirmationDialog';
import { SuccessToaster, ErrorToaster } from '../../../Components/Toaster/Toaster';
import { baseUrl } from '../../../../axios';
import { toast } from 'react-toastify';
import { useForm } from 'react-hook-form';
import moment from 'moment';
import { CircleLoading } from '../../../Components/Loaders/CircleLoading';
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

const tableHead = ["Name", "Created At", "Status", "Actions"];

function TablePaginationActions(props) {
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        <KeyboardArrowLeft />
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        <KeyboardArrowRight />
      </IconButton>
    </Box>
  );
}

function AdReadCategory() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [count, setCount] = useState("");
  const [image, setImage] = useState("");
  const [status, setStatus] = useState(null);
  const [categories, setCategories] = useState([]);
  const [open, setOpen] = useState(false);
  const [uOpen, setUOpen] = useState(false);
  const [data, setData] = useState({});
  const [cOpen, setCOpen] = useState(false);
  const [id, setId] = useState("");
  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);
  const [isSortingEnabled, setIsSortingEnabled] = useState(false);

  const navigate = useNavigate();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleClickUOpen = (data) => {
    setUOpen(true);
    setData(data);
  };

  const handleUClose = () => {
    setUOpen(false);
  };

  const handleClickCOpen = (id) => {
    setCOpen(true);
    setId(id);
  };

  const handleCClose = () => {
    setCOpen(false);
  };

  const handleSortState = () => setIsSortingEnabled((prev) => !prev);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    getAllCategories("", newPage + 1, rowsPerPage)
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(Math.floor(event.target.value));
    setPage(0);
    getAllCategories("", page, event.target.value);
  };

  const getAllCategories = async (search, page, limit) => {
    setLoading(true);
    try {
      let result = await CategoriesServices.getAllCategories(
        search ? search : "",
        page ? page : 1,
        limit ? limit : 10,
        "adread"
      );
      setCategories(result?.data?.categories)
      setCount(result?.data?.totalCategory)
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  const handleFileUpload = async (file) => {
    const formData = new FormData();
    formData.append("image", file);
    try {
      const result = await CategoriesServices.uploadImage(formData);
      setImage(result?.data?.imageUrl)
    } catch (error) {
      console.log(error)
    }
  }

  const submitCategory = async (formData) => {
    const obj = {
      name: formData.name,
      imageUrl: image,
      type: "adread"
    }
    try {
      const result = await CategoriesServices.createCategory(obj);
      if (result?.responseCode == 200) {
        SuccessToaster(result?.message);
        setName("");
        setImage("");
      }
    } catch (error) {
      console.log(error);
    } finally {
      handleClose();
      getAllCategories("", page, rowsPerPage);
    }
  }

  const updateCategory = async (formData) => {
    const obj = {
      name: formData.name,
      isActive: status,
      image: image,
      type: "adread"
    }
    try {
      const result = await CategoriesServices.updateCategory(data?._id, obj);
      // console.log("triggered =>", result);
    } catch (error) {
      console.log(error)
    } finally {
      handleUClose();
      getAllCategories("", page, rowsPerPage);
    }
  }

  const deleteCategory = async () => {
    try {
      const result = await CategoriesServices.deleteCategory(id);
    } catch (error) {
      console.log(error);
    }
    finally {
      handleCClose();
      getAllCategories("", page, rowsPerPage);
    }
  }

  const submitOrder = async () => {
    const payload = categories.map((cat, index) => ({
      _id: cat._id,
      sortOrder: index + 1,
    }));
    const obj = {
      categories: payload,
    }
    try {
      const result = await CategoriesServices.updateCategorySequence(obj);
      if (result.responseCode === 200) {
        SuccessToaster("Categories order saved successfully!");
        setIsSortingEnabled((prev) => !prev)
      }
    } catch (error) {
      ErrorToaster("Failed to save Categories order.");
    } finally {
      getAllCategories("", page, rowsPerPage);
    }
  };

  useEffect(() => {
    getAllCategories();
  }, []);

  return (
    <Fragment>
      <FormDialog
        open={open}
        handleClose={handleClose}
        title={"Create Category"}
        type={"adread"}
        label={"Category Name"}
        image={image}
        action={submitCategory}
        handleFileUpload={handleFileUpload}
        setName={setName}
        name={name}
      />

      <UFormDialog
        open={uOpen}
        handleClose={handleUClose}
        title={"Update Category"}
        label={"Category Name"}
        type={"adread"}
        data={data}
        action={updateCategory}
        handleFileUpload={handleFileUpload}
        image={image}
        setImage={setImage}
        status={status}
        setStatus={setStatus}
      />

      <ConfirmationDialog
        open={cOpen}
        onClose={handleCClose}
        action={deleteCategory}
        id={id}
        title={"Delete Category"}
        btn={"Delete"}
      />
      <Box
        sx={{
          borderRadius: "12px",
        }}
      >
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
          sx={{
            background: Colors.primaryGradient,
            p: 2,
            borderRadius: "12px",
          }}
        >
          <Grid item xs={6}>
            <Box sx={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <IconButton onClick={() => navigate(-1)}>
                <KeyboardArrowLeft sx={{ color: Colors.white }} />
              </IconButton>
              <Typography variant="body1" fontWeight="bold" sx={{ color: Colors.white }}>
                Categories
              </Typography>
            </Box>
          </Grid>
          <Grid
            item
            xs={6}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <BreadCrumbs currentPage={["Categories"]} />
          </Grid>
        </Grid>
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            bgcolor: Colors.white,
            p: 2,
            borderRadius: "12px",
            textAlign: "right",
            mt: 2,
            gap: 2
          }}
        >
          <SecondaryButton
            // disabled={role !== "A" ? true : false}
            title={isSortingEnabled ? "Cancel" : "Change Order"}
            onClick={handleSortState}
          />
          {isSortingEnabled ? (
            <SecondaryButton
              // disabled={role !== "A" ? true : false}
              title="Save Order"
              onClick={() => submitOrder()}
            />
          ) : (
            <SecondaryButton
              // disabled={role !== "A" ? true : false}
              title="Create Category"
              onClick={() => handleClickOpen()}
            />
          )}
        </Box>
        {loading ? (
          <CircleLoading />
        ) : (
          <Box>
            <TableContainer
              component={Paper}
              sx={{
                "&::-webkit-scrollbar": {
                  bgcolor: Colors.white,
                  height: "8px",
                  borderRadius: "10px",
                  cursor: "pointer",
                },
                "&::-webkit-scrollbar-thumb": {
                  bgcolor: Colors.primary,
                  borderRadius: "10px",
                  cursor: "pointer",
                },
                "&.MuiPaper-root": {
                  borderRadius: "12px",
                  mt: 2,
                  boxShadow: 0,
                },
              }}
            >
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow sx={{ bgcolor: Colors.lightGray }}>
                    {tableHead.map((item, index) => (
                      <TableCell key={index} sx={{ width: "calc(100% / 4)" }}>
                        <Typography sx={{ fontWeight: "bold" }}>
                          {item}
                        </Typography>
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                {isSortingEnabled ? (
                  <DragDropContext
                    onDragEnd={(result) => {
                      if (!result.destination) return;
                      const items = Array.from(categories);
                      const [reorderedItem] = items.splice(result.source.index, 1);
                      items.splice(result.destination.index, 0, reorderedItem);
                      setCategories(items);
                    }}
                  >
                    <Droppable droppableId="categories">
                      {(provided) => {
                        return (
                          <TableBody component={"tbody"} ref={provided.innerRef} sx={{ background: Colors.whiteSmoke }} {...provided.droppableProps}>
                            {categories.map((row, ind) => (
                              <Draggable draggableId={row._id} index={ind} key={row._id}>
                                {(provided, snapshot) => (
                                  <TableRow
                                    key={ind}
                                    ref={
                                      (el) => {
                                        provided.innerRef(el)
                                        if (el && snapshot.isDragging) {
                                          const width = el.getBoundingClientRect().width;
                                          el.style.width = `${width}px`; // Lock width when dragging
                                        }
                                      }}
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                    sx={{
                                      display: snapshot.isDragging ? "table" : undefined,
                                      tableLayout: snapshot.isDragging ? "fixed" : undefined,
                                      background: snapshot.isDragging ? Colors.white : "inherit",
                                      zIndex: snapshot.isDragging ? 1500 : "auto",
                                    }}
                                  >
                                    <TableCell>
                                      {row?.name}
                                    </TableCell>
                                    {/* <TableCell>
                                                      <Box>
                                                        <CardMedia
                                                          component={"img"}
                                                          src={baseUrl + row?.image}
                                                          sx={{ width: "60px", height: "60px", objectFit: "contain", borderRadius: "50%" }}
                                                        />
                                                      </Box>
                                                    </TableCell> */}
                                    <TableCell>
                                      {row?.createdAt ? moment(row?.createdAt).format("DD-MM-YYYY") : moment().format("DD-MM-YYYY")}
                                    </TableCell>
                                    <TableCell>
                                      <Chip
                                        label={row?.isActive ? 'Active' : 'In Active'}
                                        sx={{
                                          bgcolor: row?.isActive ? Colors.success + 26 : Colors.danger + 26,
                                          color: row?.isActive ? Colors.success : Colors.danger,
                                          height: 26,
                                          textTransform: 'capitalize',
                                        }}
                                      />
                                    </TableCell>
                                    <TableCell>
                                      <Box display="flex">
                                        <Tooltip title="Edit">
                                          <IconButton
                                            onClick={() => {
                                              handleClickUOpen(row)
                                            }}
                                          >
                                            <Edit sx={{ color: Colors.success }} />
                                          </IconButton>
                                        </Tooltip>
                                        <Tooltip title="Delete">
                                          <IconButton
                                            onClick={() => {
                                              handleClickCOpen(row._id)
                                            }}
                                          >
                                            <DeleteForever sx={{ color: Colors.primary }} />
                                          </IconButton>
                                        </Tooltip>
                                      </Box>
                                    </TableCell>
                                  </TableRow>
                                )}
                              </Draggable>
                            ))}
                            {provided.placeholder}
                          </TableBody>
                        )
                      }}
                    </Droppable>
                  </DragDropContext>
                ) : (
                  <TableBody>
                    {categories.map((row, index) => (
                      <TableRow key={index}>
                        <TableCell>
                          {row?.name}
                        </TableCell>
                        {/* <TableCell>
                        <Box>
                          <CardMedia
                            component={"img"}
                            src={baseUrl + row?.image}
                            sx={{ width: "60px", height: "60px", objectFit: "contain", borderRadius: "50%" }}
                          />
                        </Box>
                      </TableCell> */}
                        <TableCell>
                          {row?.createdAt ? moment(row?.createdAt).format("DD-MM-YYYY") : moment().format("DD-MM-YYYY")}
                        </TableCell>
                        <TableCell>
                          <Chip
                            label={row?.isActive ? 'Active' : 'In Active'}
                            sx={{
                              bgcolor: row?.isActive ? Colors.success + 26 : Colors.danger + 26,
                              color: row?.isActive ? Colors.success : Colors.danger,
                              height: 26,
                              textTransform: 'capitalize',
                            }}
                          />
                        </TableCell>
                        <TableCell>
                          <Box display="flex">
                            <Tooltip title="Edit">
                              <IconButton
                                onClick={() => {
                                  handleClickUOpen(row)
                                }}
                              >
                                <Edit sx={{ color: Colors.success }} />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Delete">
                              <IconButton
                                onClick={() => {
                                  handleClickCOpen(row._id)
                                }}
                              >
                                <DeleteForever sx={{ color: Colors.primary }} />
                              </IconButton>
                            </Tooltip>
                          </Box>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                )}
              </Table>
            </TableContainer>
            <Table sx={{ marginTop: "12px" }}>
              <TablePagination
                sx={{
                  borderBottom: "none",
                  bgcolor: Colors.white,
                  borderRadius: "12px",
                }}
                rowsPerPageOptions={[10, 20, 30]}
                colSpan={12}
                count={+count}
                rowsPerPage={rowsPerPage}
                page={page}
                SelectProps={{
                  inputProps: {
                    "aria-label": "rows per page",
                  },
                  native: true,
                }}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
                ActionsComponent={TablePaginationActions}
              />
            </Table>
          </Box>
        )}
      </Box>
    </Fragment >
  )
}

export default AdReadCategory;